import {axiosPrivate} from '../../../../libs/axios'

export function getHSOptions(axiosPrivate) {
  return axiosPrivate.get('/master-data/get-hs-options')
}

export function getHSCategoryByID(axiosPrivate, params) {
  const id = params.idHS
  return axiosPrivate.get(`/master-data/get-hs-cateogry-by-id/${id}`)
}

export function createHSCategory(axiosPrivate, formData) {
  return axiosPrivate.post('master-data/store-hs-category', formData)
}

export function updateHSCategoryById(axiosPrivate, id, formData) {
  return axiosPrivate.post(`/master-data/update-hs-category/${id}`, formData)
}

export function createHSCode(axiosPrivate, id, formData) {
  return axiosPrivate.post(`/master-data/store-hs-code/${id}`, formData)
}

export function exportTemplate(axiosPrivate) {
  return axiosPrivate.get('/master-data/export-template-hs-category-list', {
    responseType: 'blob',
  })
}

export function deleteHSCode(axiosPrivate, id) {
  return axiosPrivate.delete(`/master-data/delete-hs-code/${id}`)
}
